export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./card-course.vue?vue&type=template&id=37686f54&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/card-course/card-course.vue?vue&type=template&id=37686f54&
// module id = 1187
// module chunks = 0